import PropTypes from 'prop-types'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Button } from 'components/button'
import { UnstyledLink } from '../../../typography/UnstyledLink'
import { Link } from '../../../typography/Link'
import { Tag } from '../../../tag'
import * as styles from './JobListing.module.scss'

const JobListing = ({ index, roleTitle, location, type, department, link }) => {
  const parsedLocation = location.replace(', United States', '')
  return (
    <tr className={styles.listingContainer}>
      <td className={styles.roleContainer} data-qa={`jobListing-${roleTitle}`}>
        <UnstyledLink
          to={link}
          data-qa={`${roleTitle}-role-link`}
          alt={`${roleTitle}-role-link`}
          aria-label={`link to ${roleTitle} position page`}
        >
          {roleTitle}
        </UnstyledLink>
      </td>
      <td className={styles.locationContainer}>
        <p>{parsedLocation}</p>
      </td>
      <td className={styles.roleTypeContainer}>
        <p>{type}</p>
      </td>
      <td className={styles.applyContainer}>
        <Button url={link} alt={`View Job listing for ${roleTitle}`}>
          View Role
        </Button>
      </td>
    </tr>
  )
}

export { JobListing }
export default JobListing
